import { getChatbotHost } from '@/config/core';
import createRequest from './createRequest';
import { getChatbotApiHeaders } from './request';

export const reportAPI = createRequest({ report: false, baseURL: `${getChatbotHost()}/report/v1`, headers: { 'shopee-region': COUNTRY }});

reportAPI?.interceptors?.request?.use((config) => {
  const headers = getChatbotApiHeaders();
  Object.keys(headers).forEach((v) => {
    config.headers.common[v] = (headers as any)[v];
  });
  return config;
});
